module.exports = __webpack_public_path__ + "img/bar-all-hover.6da066fb.svg";